class NexitaRepProduct extends HTMLElement {
  connectedCallback() {
    if (this.dataset.repReady === 'true') return;
    this.dataset.repReady = 'true';

    this.parisPartsFormatter = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    this.parisLabelFormatter = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris',
      day: 'numeric',
      month: 'long',
    });
    this.activeParisDate = '';
    this.activeCutoff = 0;

    this.updateOffer();
    this.offerInterval = window.setInterval(() => this.updateOffer(), 1000);

    this.querySelectorAll('.nexita-rep-price-explanation, .nexita-rep-details__accordions details').forEach((details) => {
      this.updateDisclosure(details);
      details.addEventListener('toggle', () => this.updateDisclosure(details));
    });
  }

  disconnectedCallback() {
    window.clearInterval(this.offerInterval);
  }

  parisDateKey(date) {
    const values = {};
    this.parisPartsFormatter.formatToParts(date).forEach((part) => {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    return `${values.year}-${values.month}-${values.day}`;
  }

  nextParisMidnight(now) {
    const currentKey = this.parisDateKey(now);
    let low = now.getTime();
    let high = low + (30 * 60 * 60 * 1000);
    while (this.parisDateKey(new Date(high)) === currentKey) high += 6 * 60 * 60 * 1000;

    while (high - low > 1000) {
      const middle = Math.floor((low + high) / 2);
      if (this.parisDateKey(new Date(middle)) === currentKey) low = middle;
      else high = middle;
    }
    return high;
  }

  updateOffer() {
    const now = new Date();
    const currentParisDate = this.parisDateKey(now);

    if (currentParisDate !== this.activeParisDate) {
      this.activeParisDate = currentParisDate;
      this.activeCutoff = this.nextParisMidnight(now);
      const label = this.parisLabelFormatter.format(now);
      this.querySelectorAll('[data-rep-date]').forEach((node) => {
        node.textContent = label;
        if (node.tagName === 'TIME') node.dateTime = currentParisDate;
      });
    }

    const remaining = Math.max(0, this.activeCutoff - now.getTime());
    const hours = Math.floor(remaining / 3600000);
    const minutes = Math.floor((remaining % 3600000) / 60000);
    const label = `${String(hours).padStart(2, '0')} h ${String(minutes).padStart(2, '0')} min`;
    this.querySelectorAll('[data-rep-countdown]').forEach((node) => { node.textContent = label; });
  }

  updateDisclosure(details) {
    const indicator = details.querySelector('summary > span:last-child');
    if (indicator) indicator.textContent = details.open ? '−' : '＋';
  }
}

if (!customElements.get('nexita-rep-product')) {
  customElements.define('nexita-rep-product', NexitaRepProduct);
}
